<template>
	<div v-if="!isLoading" class="__record">
		<div v-if="!isLoading" class="__record__content">
			<div
				v-if="applyRangeLabel && timeTable.length > 0"
				class="mt-6 -mb-4"
			>
				<div class="text-xl font-semibold text-neutral-600">
					{{ applyRangeLabel }}
				</div>
				<div
					v-if="nextApplyDate"
					class="mt-1 text-base font-normal text-neutral-500"
				>
					Thời khoá biểu mới sẽ áp dụng vào {{ nextApplyDate }}.
					<span
						class="text-green-500 cursor-pointer underline"
						@click="viewNextTimetable"
						>Xem ngay</span
					>
				</div>
			</div>
			<div
				v-if="timeTable.length > 0"
				id="timetable__table__box"
				class="mt-10 relative"
			>
				<div
					v-if="scrollWidth > 0 && scrollRightPosition > 0"
					class="absolute bg-white h-full w-8 -right-8 border border-l flex items-center justify-center cursor-pointer"
					@click="scrollRight"
				>
					<div class="fixed top-1/2 -translate-x-1/2">
						<svg
							fill="none"
							height="24"
							viewBox="0 0 24 24"
							width="24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9 5L16 12L9 19"
								stroke="#E5A42B"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
						</svg>
					</div>
				</div>
				<div
					v-if="scrollWidth > 0 && scrollLeftPosition > 0"
					class="absolute bg-white h-full w-8 -left-6 border border-l flex items-center justify-center cursor-pointer"
					@click="scrollLeft"
				>
					<div class="fixed top-1/2 -translate-x-1/2">
						<svg
							fill="none"
							height="24"
							viewBox="0 0 24 24"
							width="24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M15 5L8 12L15 19"
								stroke="#E5A42B"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
						</svg>
					</div>
				</div>
				<div
					id="timetable__table"
					class="__record__table overflow-x-auto scroll-bar"
					@scroll="onTableScroll()"
				>
					<div class="overflow-hidden sm:rounded-t-2xl w-fit">
						<table class="divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32 whitespace-nowrap"
										scope="col"
										style="width: 200px"
									>
										Học sinh
									</th>
									<th
										v-for="i in 7"
										:key="i"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border-l"
										scope="col"
										style="
											width: 12.5%;
											min-width: 150px;
											max-width: 170px;
										"
									>
										{{
											i !== 7
												? `Thứ ${i + 1}`
												: 'Chủ nhật'
										}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(item, index) in students_map"
									:key="index"
									:class="{ 'border-t': index !== 0 }"
									class="bg-white text-neutral-700"
								>
									<td
										class="p-2"
										style="
											width: 200px;
											vertical-align: top;
										"
									>
										<div>
											<div
												v-if="item"
												class="flex items-start cursor-pointer"
												@click="
													$router.push({
														path: `/timetable-student/${item.id}`,
														query: {
															type: studentTimetableType,
															...($route.query
																.activated_date
																? {
																		activated_date:
																			$route
																				.query
																				.activated_date,
																  }
																: {}),
														},
													})
												"
											>
												<div class="h-6 w-6">
													<img
														v-if="
															item?.profile_photo
																?.w200
														"
														:src="
															item?.profile_photo
																?.w200
														"
														alt=""
														class="shadow-sm w-full h-full rounded-full"
													/>
													<div
														v-else
														:style="{
															background:
																item
																	?.profile_photo
																	?.default
																	?.color,
														}"
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
													>
														<div
															class="font-medium leading-none text-white text-xs"
														>
															{{
																item
																	?.profile_photo
																	?.default
																	?.initial
															}}
														</div>
													</div>
												</div>
												<div
													class="ml-4 text-orange-600 font-semibold whitespace-pre-wrap w-40"
												>
													{{ item.name }}
												</div>
											</div>
											<div
												class="flex items-center justify-end gap-4 mt-4"
											>
												<div
													v-if="
														students_map_daycare[
															item.id
														]
													"
												>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M5.99666 20C6.21401 19.9999 6.4291 19.9559 6.62903 19.8706C6.82897 19.7854 7.00964 19.6607 7.16022 19.5039C7.3108 19.3472 7.42819 19.1617 7.50536 18.9585C7.58253 18.7553 7.61788 18.5386 7.60931 18.3214L7.33907 9.88249L8.5167 9.17284C8.8171 8.99077 9.06357 8.73196 9.23077 8.42305C9.39797 8.11413 9.47987 7.76625 9.46803 7.41518L9.23294 0.617447C9.22724 0.453467 9.15807 0.298112 9.04002 0.184158C8.92197 0.0702041 8.76427 0.00656322 8.60019 0.00666215C8.43688 0.00828381 8.28053 0.0729825 8.16383 0.187227C8.04713 0.301471 7.97912 0.456412 7.97402 0.619645L7.80924 4.85559C7.80781 4.98185 7.76112 5.1034 7.67766 5.19815C7.5942 5.2929 7.47951 5.35455 7.35445 5.37191C7.28497 5.37951 7.21467 5.37268 7.14795 5.35184C7.08124 5.33101 7.01954 5.29662 6.96674 5.25082C6.91393 5.20503 6.87116 5.14883 6.84109 5.08573C6.81102 5.02264 6.79431 4.95401 6.792 4.88416L6.62722 0.643812C6.62335 0.498377 6.57147 0.358308 6.47966 0.245442C6.38786 0.132576 6.26129 0.0532551 6.1197 0.0198446C6.03534 0.00562738 5.94919 0.00562738 5.86484 0.0198446C5.72324 0.0532551 5.59667 0.132576 5.50487 0.245442C5.41306 0.358308 5.36118 0.498377 5.35731 0.643812L5.19253 4.88416C5.19022 4.95401 5.17351 5.02264 5.14344 5.08573C5.11337 5.14883 5.0706 5.20503 5.01779 5.25082C4.96499 5.29662 4.9033 5.33101 4.83658 5.35184C4.76986 5.37268 4.69956 5.37951 4.63008 5.37191C4.50502 5.35455 4.39033 5.2929 4.30687 5.19815C4.22341 5.1034 4.17672 4.98185 4.17529 4.85559L4.00392 0.619645C3.99875 0.45336 3.92829 0.295802 3.80781 0.181078C3.68733 0.0663532 3.52652 0.00369344 3.36018 0.00666215C3.1961 0.00656322 3.0384 0.0702041 2.92034 0.184158C2.80229 0.298112 2.73312 0.453467 2.72742 0.617447L2.50112 7.41738C2.48929 7.76844 2.57118 8.11632 2.73838 8.42524C2.90558 8.73416 3.15206 8.99296 3.45245 9.17503L4.65205 9.89567L4.38181 18.3214C4.37323 18.5388 4.40865 18.7557 4.48596 18.959C4.56326 19.1623 4.68085 19.3479 4.83166 19.5047C4.98248 19.6615 5.16341 19.7862 5.36361 19.8713C5.5638 19.9564 5.77913 20.0002 5.99666 20Z"
															fill="#84CC16"
														/>
														<path
															d="M17.8125 8.24569C18.1252 7.6708 18.287 7.026 18.2827 6.37159C18.2673 4.22065 17.8784 0.0220559 14.7872 8.5179e-05C11.6959 -0.0218855 11.307 4.21187 11.2916 6.37159C11.2866 7.0258 11.4477 7.6706 11.7596 8.24569C12.0901 8.85577 12.5779 9.3663 13.1723 9.72431L13.4623 9.90008L13.1943 18.3214C13.1863 18.5355 13.2216 18.7489 13.298 18.9489C13.3744 19.149 13.4904 19.3316 13.639 19.4858C13.7876 19.64 13.9658 19.7627 14.1629 19.8465C14.3599 19.9303 14.5719 19.9735 14.7861 19.9735C15.0002 19.9735 15.2122 19.9303 15.4093 19.8465C15.6063 19.7627 15.7845 19.64 15.9331 19.4858C16.0817 19.3316 16.1977 19.149 16.2741 18.9489C16.3505 18.7489 16.3858 18.5355 16.3778 18.3214L16.1032 9.89568L16.3932 9.71992C16.9894 9.36403 17.4795 8.855 17.8125 8.24569Z"
															fill="#84CC16"
														/>
													</svg>
												</div>
												<div
													v-if="
														personal_student_ids[
															item.id
														]
													"
												>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M3.75061 3.29112V2.48667C3.75061 2.36994 3.72762 2.25433 3.68291 2.1465C3.67335 2.12341 3.66282 2.10078 3.65143 2.07865C3.63719 2.05104 3.62147 2.02423 3.60443 1.99829C3.58424 1.96762 3.56216 1.93817 3.53831 1.9102C3.523 1.89224 3.50698 1.87485 3.49024 1.85811C3.40769 1.77556 3.30973 1.7101 3.20185 1.66545C3.09402 1.62079 2.97841 1.5978 2.86168 1.5978H1.77724C1.77724 1.17401 1.9456 0.767619 2.24523 0.467987C2.54486 0.168355 2.95125 0 3.37504 0H17.9573C18.1671 0 18.3748 0.0413513 18.5687 0.121613C18.7625 0.201925 18.9386 0.319621 19.087 0.467987C19.2354 0.616353 19.3531 0.792491 19.4334 0.986328C19.5137 1.18017 19.555 1.38794 19.555 1.5978V18.4022C19.555 18.6121 19.5137 18.8198 19.4334 19.0137C19.3531 19.2075 19.2354 19.3836 19.087 19.532C18.9386 19.6804 18.7625 19.7981 18.5687 19.8784C18.3748 19.9586 18.1671 20 17.9573 20H3.37504C2.95125 20 2.54486 19.8316 2.24523 19.532C1.9456 19.2324 1.77724 18.826 1.77724 18.4022H2.86168C2.97841 18.4022 3.09402 18.3792 3.20185 18.3346C3.30973 18.2899 3.40769 18.2244 3.49024 18.1419C3.57279 18.0593 3.63825 17.9613 3.68291 17.8535C3.72762 17.7457 3.75061 17.6301 3.75061 17.5133V16.7089C3.75061 16.5922 3.72762 16.4766 3.68291 16.3687C3.63825 16.2609 3.57279 16.1629 3.49024 16.0803C3.45871 16.0488 3.42489 16.0197 3.38913 15.9934C3.33135 15.9508 3.26848 15.9152 3.20185 15.8877C3.09402 15.843 2.97841 15.82 2.86168 15.82H1.77724V14.8466H2.86168C2.97841 14.8466 3.09402 14.8237 3.20185 14.779C3.30973 14.7343 3.40769 14.6689 3.49024 14.5863C3.57279 14.5038 3.63825 14.4058 3.68291 14.2979C3.68932 14.2825 3.69527 14.267 3.70076 14.2513C3.71292 14.2166 3.72284 14.1812 3.73057 14.1454C3.73912 14.1058 3.74496 14.0656 3.74807 14.0252C3.74975 14.0028 3.75061 13.9803 3.75061 13.9578V13.1533C3.75061 13.0366 3.72762 12.921 3.68291 12.8132C3.67386 12.7912 3.66389 12.7697 3.65316 12.7487C3.64014 12.7232 3.6259 12.6984 3.61048 12.6744C3.58312 12.6316 3.55214 12.5911 3.51776 12.5536C3.50881 12.5438 3.49965 12.5342 3.49024 12.5248C3.45561 12.4901 3.41822 12.4585 3.3785 12.4301C3.32367 12.3909 3.26441 12.358 3.20185 12.3321C3.09402 12.2874 2.97841 12.2645 2.86168 12.2645H1.77724V11.2911H2.86168C2.97841 11.2911 3.09402 11.2681 3.20185 11.2234C3.30973 11.1788 3.40769 11.1133 3.49024 11.0308C3.57279 10.9482 3.63825 10.8502 3.68291 10.7424C3.72762 10.6346 3.75061 10.519 3.75061 10.4022V9.59778C3.75061 9.48105 3.72762 9.36544 3.68291 9.25761C3.63825 9.14978 3.57279 9.05177 3.49024 8.96922C3.40769 8.88667 3.30973 8.82121 3.20185 8.77655C3.09402 8.73189 2.97841 8.7089 2.86168 8.7089H1.77724V7.73554H2.86168C2.97841 7.73554 3.09402 7.71255 3.20185 7.6679C3.30973 7.62324 3.40769 7.55773 3.49024 7.47523C3.57279 7.39268 3.63825 7.29467 3.68291 7.18684C3.7118 7.11716 3.73164 7.04422 3.74201 6.96986C3.74466 6.95084 3.74674 6.93176 3.74817 6.91264C3.7498 6.89072 3.75061 6.86869 3.75061 6.84667V6.04223C3.75061 5.9255 3.72762 5.80989 3.68291 5.70206C3.63825 5.59423 3.57279 5.49622 3.49024 5.41367C3.40769 5.33112 3.30973 5.26566 3.20185 5.221C3.14885 5.19903 3.09397 5.18234 3.03797 5.171C2.98009 5.1593 2.92104 5.15335 2.86168 5.15335H1.77724V4.17999H2.86168C2.97841 4.17999 3.09402 4.157 3.20185 4.11235C3.30973 4.06769 3.40769 4.00218 3.49024 3.91968C3.57279 3.83713 3.63825 3.73912 3.68291 3.63129C3.72762 3.52341 3.75061 3.40785 3.75061 3.29112ZM2.8627 2.26481H0.666555C0.543823 2.26481 0.444336 2.3643 0.444336 2.48703V3.29081C0.444336 3.41354 0.543823 3.51303 0.666555 3.51303H2.8627C2.98543 3.51303 3.08492 3.41354 3.08492 3.29081V2.48703C3.08492 2.3643 2.98543 2.26481 2.8627 2.26481ZM0.666555 9.37592H2.8627C2.98543 9.37592 3.08492 9.4754 3.08492 9.59813V10.4019C3.08492 10.5246 2.98543 10.6241 2.8627 10.6241H0.666555C0.543823 10.6241 0.444336 10.5246 0.444336 10.4019V9.59813C0.444336 9.4754 0.543823 9.37592 0.666555 9.37592ZM2.8627 5.82036H0.666555C0.617167 5.82036 0.571543 5.83649 0.534668 5.8637C0.479889 5.90418 0.444336 5.96924 0.444336 6.04258V6.84636C0.444336 6.9691 0.543823 7.06858 0.666555 7.06858H2.8627C2.98543 7.06858 3.08492 6.9691 3.08492 6.84636V6.04258C3.08492 5.91985 2.98543 5.82036 2.8627 5.82036ZM2.8627 12.9315H0.666555C0.543823 12.9315 0.444336 13.031 0.444336 13.1537V13.9575C0.444336 14.0802 0.543823 14.1797 0.666555 14.1797H2.8627C2.98543 14.1797 3.08492 14.0802 3.08492 13.9575V13.1537C3.08492 13.031 2.98543 12.9315 2.8627 12.9315ZM2.8627 16.487H0.666555C0.543823 16.487 0.444336 16.5865 0.444336 16.7092V17.513C0.444336 17.6358 0.543823 17.7352 0.666555 17.7352H2.8627C2.98543 17.7352 3.08492 17.6358 3.08492 17.513V16.7092C3.08492 16.5865 2.98543 16.487 2.8627 16.487ZM14.9997 7.91667C14.9997 9.98773 13.3208 11.6667 11.2497 11.6667C9.17863 11.6667 7.49969 9.98773 7.49969 7.91667C7.49969 5.8456 9.17863 4.16667 11.2497 4.16667C13.3208 4.16667 14.9997 5.8456 14.9997 7.91667ZM17.4997 15.1108C17.4997 15.1108 16.2497 12.9167 11.2497 12.9167C6.24969 12.9167 4.99969 15.1109 4.99969 15.1109V15.4167C4.99969 16.107 5.55934 16.6667 6.2497 16.6667H16.2497C16.9401 16.6667 17.4997 16.107 17.4997 15.4167V15.1108Z"
															fill="#818CF8"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div
													v-if="
														group_class_map[item.id]
													"
												>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M8.75 17.5C8.75 17.5 7.5 17.5 7.5 16.25C7.5 15 8.75 11.25 13.75 11.25C18.75 11.25 20 15 20 16.25C20 17.5 18.75 17.5 18.75 17.5H8.75Z"
															fill="#86A8D0"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M13.75 10C15.8211 10 17.5 8.32107 17.5 6.25C17.5 4.17893 15.8211 2.5 13.75 2.5C11.6789 2.5 10 4.17893 10 6.25C10 8.32107 11.6789 10 13.75 10Z"
															fill="#86A8D0"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M6.52045 17.5C6.34445 17.1449 6.25 16.7239 6.25 16.25C6.25 14.5557 7.09882 12.8132 8.66991 11.6C7.98262 11.3801 7.18137 11.25 6.25 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H6.52045Z"
															fill="#86A8D0"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M5.625 10C7.35089 10 8.75 8.60089 8.75 6.875C8.75 5.14911 7.35089 3.75 5.625 3.75C3.89911 3.75 2.5 5.14911 2.5 6.875C2.5 8.60089 3.89911 10 5.625 10Z"
															fill="#86A8D0"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
											</div>
										</div>
									</td>
									<td
										v-for="index in 7"
										:key="index"
										class="border-l p-2 space-y-2 items-start"
										style="
											width: 12.5%;
											min-width: 150px;
											max-width: 170px;
											vertical-align: top;
										"
									>
										<div
											v-for="(
												data, i
											) in getTimeTableData(
												item.id,
												index
											)"
											:key="i"
										>
											<div
												v-if="data.day_care_class"
												:class="
													data.overlapped
														? 'bg-sienna-100'
														: 'bg-lime-100'
												"
												class="p-2 border-l-2 border-lime-600 rounded-lg mb-2 flex items-center justify-between gap-2 w-full"
											>
												<div
													class="font-semibold text-neutral-600 whitespace-nowrap truncate text-sm"
												>
													{{
														data.day_care_class.name
													}}
												</div>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 21 20"
														width="21"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M6.32967 20C6.54702 19.9999 6.7621 19.9559 6.96204 19.8706C7.16198 19.7854 7.34265 19.6607 7.49323 19.5039C7.64381 19.3472 7.7612 19.1617 7.83837 18.9585C7.91554 18.7553 7.95089 18.5386 7.94232 18.3214L7.67208 9.88249L8.84971 9.17284C9.1501 8.99077 9.39658 8.73196 9.56378 8.42305C9.73098 8.11413 9.81287 7.76625 9.80104 7.41518L9.56595 0.617447C9.56025 0.453467 9.49108 0.298112 9.37303 0.184158C9.25498 0.0702041 9.09727 0.00656322 8.93319 0.00666215C8.76989 0.00828381 8.61354 0.0729825 8.49684 0.187227C8.38014 0.301471 8.31213 0.456412 8.30703 0.619645L8.14225 4.85559C8.14082 4.98185 8.09413 5.1034 8.01067 5.19815C7.92721 5.2929 7.81252 5.35455 7.68746 5.37191C7.61798 5.37951 7.54768 5.37268 7.48096 5.35184C7.41424 5.33101 7.35255 5.29662 7.29975 5.25082C7.24694 5.20503 7.20417 5.14883 7.1741 5.08573C7.14403 5.02264 7.12732 4.95401 7.12501 4.88416L6.96023 0.643812C6.95636 0.498377 6.90447 0.358308 6.81267 0.245442C6.72087 0.132576 6.5943 0.0532551 6.4527 0.0198446C6.36835 0.00562738 6.2822 0.00562738 6.19784 0.0198446C6.05624 0.0532551 5.92968 0.132576 5.83788 0.245442C5.74607 0.358308 5.69419 0.498377 5.69032 0.643812L5.52554 4.88416C5.52323 4.95401 5.50652 5.02264 5.47645 5.08573C5.44638 5.14883 5.40361 5.20503 5.3508 5.25082C5.298 5.29662 5.2363 5.33101 5.16959 5.35184C5.10287 5.37268 5.03257 5.37951 4.96309 5.37191C4.83803 5.35455 4.72334 5.2929 4.63988 5.19815C4.55642 5.1034 4.50973 4.98185 4.5083 4.85559L4.33693 0.619645C4.33175 0.45336 4.2613 0.295802 4.14082 0.181078C4.02034 0.0663532 3.85952 0.00369344 3.69319 0.00666215C3.52911 0.00656322 3.3714 0.0702041 3.25335 0.184158C3.1353 0.298112 3.06613 0.453467 3.06043 0.617447L2.83413 7.41738C2.82229 7.76844 2.90419 8.11632 3.07139 8.42524C3.23859 8.73416 3.48507 8.99296 3.78546 9.17503L4.98506 9.89567L4.71482 18.3214C4.70624 18.5388 4.74166 18.7557 4.81896 18.959C4.89627 19.1623 5.01385 19.3479 5.16467 19.5047C5.31549 19.6615 5.49642 19.7862 5.69661 19.8713C5.89681 19.9564 6.11213 20.0002 6.32967 20Z"
															fill="#65A30D"
														/>
														<path
															d="M18.1455 8.24569C18.4582 7.6708 18.62 7.026 18.6157 6.37159C18.6003 4.22065 18.2114 0.0220559 15.1202 8.5179e-05C12.0289 -0.0218855 11.64 4.21187 11.6246 6.37159C11.6197 7.0258 11.7807 7.6706 12.0926 8.24569C12.4232 8.85577 12.9109 9.3663 13.5053 9.72431L13.7953 9.90008L13.5273 18.3214C13.5193 18.5355 13.5546 18.7489 13.631 18.9489C13.7074 19.149 13.8234 19.3316 13.972 19.4858C14.1206 19.64 14.2988 19.7627 14.4959 19.8465C14.6929 19.9303 14.9049 19.9735 15.1191 19.9735C15.3332 19.9735 15.5452 19.9303 15.7423 19.8465C15.9394 19.7627 16.1175 19.64 16.2661 19.4858C16.4147 19.3316 16.5307 19.149 16.6071 18.9489C16.6835 18.7489 16.7188 18.5355 16.7108 18.3214L16.4362 9.89568L16.7262 9.71992C17.3225 9.36403 17.8125 8.855 18.1455 8.24569Z"
															fill="#65A30D"
														/>
													</svg>
												</div>
											</div>
											<div
												v-else
												:class="
													data.overlapped
														? 'bg-sienna-100 border-sienna-600'
														: data.group_class_id
														? 'bg-blue-100 border-blue-600'
														: 'bg-violet-100 border-violet-600'
												"
												class="p-2 border-l-2 rounded-lg flex w-full items-center justify-between gap-2 relative"
												@mouseleave="showhover = false"
												@mouseover="showHover(data.id)"
											>
												<div
													v-if="
														data.id == id &&
														showhover &&
														!data.group_class_id
													"
													class="absolute hover-block font-normal z-10"
												>
													<div
														class="whitespace-nowrap"
													>
														<span
															class="font-semibold"
															>Áp dụng vào:
														</span>
														{{
															formatDate(
																data.inserted_at
															)
														}}
													</div>
													<div
														class="whitespace-nowrap"
													>
														<span
															class="font-semibold"
															>Tạo bởi:
														</span>
														{{
															data
																?.created_by_staff
																?.name ||
															getStaff(
																data?.created_by_staff_id
															)?.name
														}}
													</div>
												</div>
												<div
													class="font-semibold text-neutral-600 whitespace-nowrap text-sm"
												>
													{{
														data.display_start_slot
													}}
													-
													{{ data.display_end_slot }}
												</div>
												<div
													class="flex items-center justify-end"
												>
													<Popper :arrow="true" hover>
														<div
															class="flex items-center justify-end gap-1"
														>
															<div
																v-for="(
																	staff_id, i
																) in data.staff_ids?.slice(
																	0,
																	2
																)"
																:key="staff_id"
																class="flex items-center"
															>
																<div
																	class="h-6 w-6"
																>
																	<img
																		v-if="
																			getStaff(
																				staff_id
																			)
																				?.profile_photo
																				?.w200
																		"
																		:src="
																			getStaff(
																				staff_id
																			)
																				?.profile_photo
																				?.w200
																		"
																		alt=""
																		class="shadow-sm w-full h-full rounded-full"
																		:class="{
																			'm-avatar':
																				data
																					.staff_ids
																					?.length >
																					2 &&
																				i ==
																					1,
																		}"
																	/>
																	<div
																		v-else
																		:style="{
																			background:
																				getStaff(
																					staff_id
																				)
																					?.profile_photo
																					?.default
																					?.color,
																		}"
																		:class="{
																			'm-avatar':
																				data
																					.staff_ids
																					?.length >
																					2 &&
																				i ==
																					1,
																		}"
																		class="flex items-center justify-center h-6 w-6 rounded-full"
																	>
																		<div
																			class="font-medium leading-none text-white text-xs"
																		>
																			{{
																				getStaff(
																					staff_id
																				)
																					?.profile_photo
																					?.default
																					?.initial
																			}}
																		</div>
																	</div>
																</div>
															</div>
															<div
																v-if="
																	data
																		.staff_ids
																		?.length >
																	2
																"
																class="flex items-center m-number"
															>
																<div
																	class="h-6 w-6"
																>
																	<div
																		class="flex items-center justify-center h-6 w-6 rounded-full bg-gray-300"
																	>
																		<div
																			class="font-semibold leading-none text-white text-xs"
																		>
																			+{{
																				data
																					.staff_ids
																					?.length -
																				2
																			}}
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<template #content>
															<div
																class="flex flex-wrap gap-3"
																style="
																	max-width: 360px;
																"
															>
																<div
																	v-for="(
																		item,
																		index
																	) in [
																		...data.staff_ids,
																	].reverse()"
																	:key="
																		getStaff(
																			item
																		)?.id
																	"
																	class="flex flex-nowrap gap-3 items-center"
																	style="
																		width: 160px;
																	"
																>
																	<div
																		:style="{
																			zIndex:
																				data
																					?.staff_ids
																					?.length -
																				index,
																		}"
																		class="rounded-full"
																	>
																		<img
																			v-if="
																				getStaff(
																					item
																				)
																					?.profile_photo
																					?.w200
																			"
																			:class="`h-9 w-9`"
																			:src="
																				getStaff(
																					item
																				)
																					?.profile_photo
																					?.w200
																			"
																			alt=""
																			class="shadow-sm inline-block rounded-full"
																		/>
																		<span
																			v-else
																			:class="`h-9 w-9`"
																			:style="{
																				background:
																					getStaff(
																						item
																					)
																						?.profile_photo
																						?.default
																						?.color,
																			}"
																			class="inline-flex items-center justify-center rounded-full"
																		>
																			<span
																				class="font-medium leading-none text-white text-xs"
																				>{{
																					getStaff(
																						item
																					)
																						?.profile_photo
																						?.default
																						?.initial
																				}}</span
																			>
																		</span>
																	</div>
																	<div
																		:style="{
																			color: getStaff(
																				item
																			)
																				?.profile_photo
																				?.default
																				?.color,
																		}"
																		class="font-semibold cursor-pointer hover:underline text-sm py-1"
																		@click.stop="
																			$router.push(
																				`/record/staff/${
																					getStaff(
																						item
																					)
																						.id
																				}`
																			)
																		"
																	>
																		{{
																			getStaff(
																				item
																			)
																				?.name
																		}}
																	</div>
																</div>
															</div>
														</template>
													</Popper>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div
				v-else
				class="w-full h-full flex items-center justify-center flex-col gap-6"
			>
				<img
					alt=""
					height="300"
					src="@/assets/images/illustrations/empty-tkb.svg"
					width="300"
				/>
				<div class="text-gray-500 text-center">
					Chưa có Thời khoá biểu
					<span
						v-if="Object.keys(studentSelected).length > 0"
						class="font-semibold"
						>cho {{ studentSelected.name }}</span
					><br />
					TKB được xây dựng bởi Lịch can thiệp cá nhân & Lịch học bán
					trú (nếu có). <br />
					Bạn cần tạo Lịch can thiệp cá nhân cho cơ sở để xem TKB
				</div>
				<button
					class="button-p text-center shadow-none flex items-center justify-center w-fit px-6 bg-none btn--ghost"
					type="button"
					@click="$emit('updateTimeTable')"
				>
					Tạo mới
				</button>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
	<div v-else class="fixed top-1/2 left-1/2">
		<Loading />
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { $api } from '@/services';
import dayjs from 'dayjs';
import Loading from '@/components/common/Loading';
import { toEnglish } from '@/helper/toEnglish';
import { flattenMap } from '@/helper/flattenMap';
import Popper from 'vue3-popper';
import { _ROUTER_NAME } from '@/enums';
import { scheduleKindFromRoute } from '@/helper/scheduleSection';

export default defineComponent({
	name: 'TimeTable',
	components: {
		Popper,
		Loading,
	},

	props: {
		studentSelected: {
			type: Object,
			required: true,
		},

		students: {
			type: Array,
			required: true,
		},

		onRefetch: {
			type: Number,
			default: 0,
		},
	},

	data() {
		return {
			timeTable: [],
			applyRange: null,
			students_map: {},
			students_map_daycare: {},
			personal_student_ids: {},
			group_class_map: {},
			staffs_map: {},
			params: {
				date: dayjs().format('YYYY-MM-DD'),
			},
			isLoading: true,
			scrollWidth: 0,
			scrollLeftPosition: 0,
			scrollRightPosition: 0,
			id: null,
			showhover: false,
			fetchToken: 0,
			is_current_applied: false,
		};
	},

	created() {
		const activatedDate = this.$route.query.activated_date;
		const date = Array.isArray(activatedDate)
			? activatedDate[0]
			: activatedDate;
		if (date) {
			this.params.date = date;
		}
		const student = this.$route.query.student;
		const studentId = Array.isArray(student) ? student[0] : student;
		if (studentId) {
			this.params.student_id = studentId;
		}
		this.fetchTimeTable();
	},

	mounted() {
		const time = setInterval(() => {
			const table = document.getElementById('timetable__table');
			if (table) {
				this.setScrollWidth();
				this.onTableScroll();
				clearInterval(time);
			}
		}, 1000);
		window.addEventListener('resize', this.setScrollWidth);
	},

	unmounted() {
		window.removeEventListener('resize', this.setScrollWidth);
	},

	watch: {
		studentSelected: {
			deep: true,
			handler(value) {
				const studentId = value?.id;
				if (
					String(studentId || '') ===
					String(this.params.student_id || '')
				) {
					return;
				}
				this.params = {
					...this.params,
					student_id: studentId,
				};
				this.fetchTimeTable();
			},
		},

		onRefetch: {
			handler() {
				this.fetchTimeTable();
			},
		},

		timetableScope() {
			// the route changes before this view unmounts, skip when leaving
			if (
				![
					_ROUTER_NAME.SCHEDULE_TIMETABLE_CLASS,
					_ROUTER_NAME.FACILITY_TIMETABLE,
				].includes(this.$route.name)
			) {
				return;
			}
			this.applyActivatedDate();
			this.isLoading = true;
			this.fetchTimeTable();
		},

		'$route.query.activated_date'() {
			this.applyActivatedDate();
			this.fetchTimeTable();
		},
	},

	computed: {
		oldPayload() {
			return {
				'x-cross': this.$route.query.org_id,
			};
		},

		is_old_data() {
			return this.$route.query.is_old_data === 'true';
		},

		applyRangeLabel() {
			if (!this.applyRange?.start_date) return '';
			const { start_date, end_date } = this.applyRange;
			const prefix = this.is_current_applied ? 'TKB hiện tại · ' : '';
			return (
				prefix +
				'Áp dụng từ ' +
				this.$filters.formatDate2(start_date) +
				(end_date
					? ' đến ' +
					  this.$filters.formatDate2(
							dayjs(end_date)
								.subtract(1, 'day')
								.format('YYYY-MM-DD')
					  )
					: '')
			);
		},

		nextApplyDate() {
			if (!this.applyRange?.start_date || !this.applyRange?.end_date) {
				return '';
			}
			return this.$filters.formatDate2(this.applyRange.end_date);
		},

		studentTimetableType() {
			return this.timetableScope === 'daycare' ? 'daycare' : undefined;
		},

		timetableScope() {
			if (this.$route.name === _ROUTER_NAME.FACILITY_TIMETABLE) {
				return 'all';
			}
			const kind = scheduleKindFromRoute(this.$route);
			return kind === 'group' ? 'personal' : kind;
		},
	},

	methods: {
		toEnglish,
		applyActivatedDate() {
			const activatedDate = this.$route.query.activated_date;
			const date = Array.isArray(activatedDate)
				? activatedDate[0]
				: activatedDate;
			this.params = {
				...this.params,
				date: date || dayjs().format('YYYY-MM-DD'),
			};
		},
		viewNextTimetable() {
			const date = this.applyRange?.end_date;
			if (!date) return;
			this.$router.push({
				query: {
					...this.$route.query,
					activated_date: date,
					deactivated_date: undefined,
				},
			});
		},
		onTableScroll() {
			const table = document.getElementById('timetable__table');
			const parent = document.getElementById('timetable__table__box');
			this.scrollLeftPosition = table?.scrollLeft || 0;
			this.scrollRightPosition =
				table.scrollWidth -
				this.scrollLeftPosition -
				parent.clientWidth;
		},

		setScrollWidth() {
			const table = document.getElementById('timetable__table');
			const parent = document.getElementById('timetable__table__box');
			if (table) {
				this.scrollWidth = table.scrollWidth > parent.clientWidth;
			}
		},
		scrollRight() {
			const table = document.getElementById('timetable__table');
			if (table) {
				table.scrollTo(table.scrollWidth, 0);
			}
		},
		scrollLeft() {
			const table = document.getElementById('timetable__table');
			if (table) {
				table.scrollTo(0, 0);
			}
		},
		async fetchTimeTable() {
			const token = ++this.fetchToken;
			const scope = this.timetableScope;
			const oldPayload = this.is_old_data ? this.oldPayload : null;
			try {
				let personalData = [];
				let personalStaffs = {};
				let personalStudents = {};
				let daycareData = [];
				let daycareStudents = {};
				let groupData = [];
				let groupStaffs = {};
				let groupStudents = {};
				let applyRange = null;
				let is_current_applied = false;
				const toIdLookup = (ids) => {
					const lookup = {};
					ids.filter(Boolean).forEach((id) => {
						lookup[id] = true;
					});
					return lookup;
				};

				if (scope === 'all' || scope === 'personal') {
					const res = await $api.schedule.fetchTimetableByWeek(
						this.params,
						oldPayload
					);
					personalData = res?.data?.data || [];
					personalStaffs = flattenMap(res?.data?.staffs_map);
					personalStudents = flattenMap(res?.data?.students_map);
					if (scope === 'personal') {
						applyRange = res?.data?.apply_range || null;
						is_current_applied = res?.data?.is_current_applied || false;
					}
				}

				if (scope === 'daycare') {
					const res =
						await $api.schedule.fetchFixedDaycareScheduleByWeek(
							this.params,
							oldPayload
						);
					const classesMap = res?.data?.day_care_classes_map || {};
					daycareStudents = flattenMap(res?.data?.students_map);
					daycareData = (res?.data?.data || [])
						.map((slot) => ({
							...slot,
							day_care_class: classesMap[slot.day_care_class_id],
						}))
						.filter((slot) => slot.day_care_class);
				} else if (scope === 'all') {
					const res = await $api.schedule.fetchTimetableByWeekDaycare(
						this.params,
						oldPayload
					);
					daycareData = res?.data?.data || [];
					daycareStudents = flattenMap(res?.data?.students_map);
				}

				if (scope === 'all') {
					const res =
						await $api.schedule.fetchFixedGroupTimeSlotsByWeek(
							this.params
						);
					const classesMap = res?.data?.group_classes_map || {};
					groupStudents = flattenMap(res?.data?.students_map);
					groupStaffs = flattenMap(res?.data?.staffs_map);
					(res?.data?.data || []).forEach((slot) => {
						const studentIds =
							classesMap[slot.group_class_id]?.student_ids || [];
						studentIds.forEach((student_id) => {
							groupData.push({ ...slot, student_id });
						});
					});
				}

				if (token !== this.fetchToken) return;

				this.timeTable = [
					...personalData,
					...daycareData,
					...groupData,
				];
				this.applyRange = applyRange;
				this.is_current_applied = is_current_applied;
				this.staffs_map = { ...personalStaffs, ...groupStaffs };
				this.students_map = {
					...groupStudents,
					...daycareStudents,
					...personalStudents,
				};
				this.personal_student_ids = toIdLookup(
					personalData.map(
						(item) => item?.student_id || item?.student?.id
					)
				);
				this.students_map_daycare = toIdLookup(
					daycareData.map(
						(item) => item?.student_id || item?.student?.id
					)
				);
				this.group_class_map = toIdLookup(
					groupData.map((item) => item?.student_id)
				);
			} catch (e) {
				console.log(e);
			} finally {
				if (token === this.fetchToken) this.isLoading = false;
			}
		},

		getTimeTableData(student_id, day) {
			return this.timeTable.filter(
				(item) =>
					(item.student_id === student_id ||
						(item.student && item.student.id === student_id)) &&
					item.day_of_week === day
			);
		},

		getStaff(staff_id) {
			return this.staffs_map[staff_id];
		},

		showHover(id) {
			this.id = id;
			this.showhover = true;
		},
		formatDate(data) {
			let dtObject = new Date(data);
			dtObject.setUTCHours(dtObject.getHours() + 7);
			if (dtObject.getHours() >= 24) {
				dtObject.setDate(dtObject.getDate() + 1);
			}
			let newTimestamp = dtObject
				.toISOString()
				.replace('T', ' ')
				.slice(0, -5);
			return newTimestamp;
		},
	},
});
</script>
<style lang="scss">
#timetable__table {
	scroll-behavior: smooth;
}

.hover-block {
	border-radius: 5px;
	background: var(--Yellow-300, #f6d692);
	padding: 16px;
	color: var(--Gray-600, #48566a);
	font-family: 'SVN-Gilroy', sans-serif !important;
	font-size: 18px;
	line-height: 24px;
	top: -70px;
	left: -60px;
}

.m-avatar {
	margin-left: -14px;
}
.m-number {
	margin-left: -28px;
}
</style>
